/* @flow */
import React from 'react';
// $FlowIgnore
import { MdSettings } from 'react-icons/md';

export default function ProcessingIcon({
  style
}: Object): React.Element {
  return <MdSettings style={style} />;
}
